import React from "react";
import {
  MAX_HEIGHT_CM,
  MAX_HEIGHT_FEET,
  MAX_WEIGHT_KG,
  MAX_WEIGHT_LBS,
  MIN_HEIGHT_CM,
  MIN_HEIGHT_FEET,
  MIN_WEIGHT_KG,
  MIN_WEIGHT_LBS,
} from "./measurementUnits";

const HeightWeightFields = ({
  values,
  onChange,
  heightError,
  weightError,
  disabled,
  metric = true,
  text = {},
  required = true,
  autoFocusHeight = false,
}) => {
  const requiredMark = required ? " *" : "";
  const heightUnit = metric
    ? text.unit_cm || "cm"
    : text.unit_ft_in || "ft & in";
  const weightUnit = metric ? text.unit_kg || "kg" : text.unit_lbs || "lbs";
  const weightMin = metric ? MIN_WEIGHT_KG : MIN_WEIGHT_LBS;
  const weightMax = metric ? MAX_WEIGHT_KG : MAX_WEIGHT_LBS;

  return (
    <div className="mmt-tp-row">
      <div className="mmt-field">
        <span>{`${text.height || "Height"} (${heightUnit})${requiredMark}`}</span>
        {metric ? (
          <input
            type="number"
            min={MIN_HEIGHT_CM}
            max={MAX_HEIGHT_CM}
            step="0.1"
            value={values.height}
            onChange={(e) => onChange("height", e.target.value)}
            className={heightError ? "mmt-input-error" : ""}
            disabled={disabled}
            autoFocus={autoFocusHeight}
          />
        ) : (
          <div className="mmt-height-imperial">
            <label>
              <input
                type="number"
                min={MIN_HEIGHT_FEET}
                max={MAX_HEIGHT_FEET}
                step="1"
                value={values.heightFeet}
                onChange={(e) => onChange("heightFeet", e.target.value)}
                className={heightError ? "mmt-input-error" : ""}
                disabled={disabled}
                autoFocus={autoFocusHeight}
                aria-label={text.height_feet_aria || "Height in feet"}
              />
              <span>{text.unit_ft || "ft"}</span>
            </label>
            <label>
              <input
                type="number"
                min="0"
                max="11"
                step="1"
                value={values.heightInches}
                onChange={(e) => onChange("heightInches", e.target.value)}
                className={heightError ? "mmt-input-error" : ""}
                disabled={disabled}
                aria-label={text.height_inches_aria || "Height in inches"}
              />
              <span>{text.unit_in || "in"}</span>
            </label>
          </div>
        )}
        {heightError ? (
          <em className="mmt-tp-hint">
            {metric
              ? text.height_hint_metric || "Enter a height from 100 to 220 cm"
              : text.height_hint_imperial ||
                "Enter a height from 3 ft 4 in to 7 ft 2 in"}
          </em>
        ) : null}
      </div>

      <label className="mmt-field">
        <span>{`${text.weight || "Weight"} (${weightUnit})${requiredMark}`}</span>
        <input
          type="number"
          min={weightMin}
          max={weightMax}
          step="0.1"
          value={values.weight}
          onChange={(e) => onChange("weight", e.target.value)}
          className={weightError ? "mmt-input-error" : ""}
          disabled={disabled}
        />
        {weightError ? (
          <em className="mmt-tp-hint">
            {(text.weight_hint || "Enter a weight from {min} to {max} {unit}")
              .replace("{min}", weightMin)
              .replace("{max}", weightMax)
              .replace("{unit}", weightUnit)}
          </em>
        ) : null}
      </label>
    </div>
  );
};

export default HeightWeightFields;
